import {
  Button,
  Checkbox,
  Divider,
  Group,
  Popover,
  Stack,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { RiFileExcel2Fill } from "react-icons/ri";
//const downloadProjection = useSetAtom(projectionsExportAtom);

import imgExportPreview from "@/assets/export-preview.png";
import { exportAtom } from "@/financeModels/owasco/export/export";
import { useSetAtom } from "jotai";
import { useState } from "react";
import { FaPlayCircle } from "react-icons/fa";
const openImagePreviewModal = () => {
  modals.open({
    size: `auto`,
    zIndex: 9999,
    centered: true,
    children: (
      <img
        style={{
          height: "36vw",
        }}
        src={imgExportPreview}
        alt="screenshot of export"
      />
    ),
  });
};

export const ExportButton = () => {
  const exportDownload = useSetAtom(exportAtom);

  const allSheets = [
    { value: "historicals", label: "Historicals" },
    { value: "amortization", label: "Amortization" },
    { value: "projections", label: "Projections" },
    { value: "roi", label: "ROI Metrics" },
    { value: "workingCapital", label: "Working Capital" },
    { value: "overview", label: "Overview" },
  ];
  const [desiredSheets, setDesiredSheets] = useState<string[]>(
    allSheets.map((s) => s.value),
  );
  const [isExporting, setIsExporting] = useState(false);

  return (
    <Popover width={360} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <Button
          radius={"xs"}
          size="xs"
          fz={"sm"}
          leftSection={
            <RiFileExcel2Fill
              style={{ marginLeft: 3, marginRight: -2 }}
              size={16}
            />
          }
        >
          Excel Export
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack>
          <Group justify="space-between" align="center">
            <Group gap={"xs"}>Export To Excel</Group>

            <Button
              variant="transparent"
              leftSection={<FaPlayCircle size={15} />}
              size="compact-sm"
              onClick={openImagePreviewModal}
            >
              SEE PREVIEW
            </Button>
          </Group>
          <Divider my="sm" />
          <Checkbox
            label="Select All"
            checked={desiredSheets.length === allSheets.length}
            onChange={(event) => {
              const checked = event.currentTarget.checked;
              setDesiredSheets(checked ? allSheets.map((s) => s.value) : []);
            }}
          />
          <Divider my="sm" />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridTemplateRows: "repeat(3, auto)",
              gridAutoFlow: "column",
              gap: "8px",
            }}
          >
            {allSheets.map((sheet) => (
              <Checkbox
                key={sheet.value}
                label={sheet.label}
                checked={desiredSheets.includes(sheet.value)}
                onChange={(event) => {
                  const checked = event.currentTarget.checked;
                  setDesiredSheets((prev) =>
                    checked
                      ? [...prev, sheet.value]
                      : prev.filter((s) => s !== sheet.value),
                  );
                }}
              />
            ))}
          </div>

          <Button
            onClick={async () => {
              setIsExporting(true);
              try {
                // Let React paint the loading state before export blocks the main thread.
                await new Promise<void>((resolve) => {
                  window.requestAnimationFrame(() => resolve());
                });
                await exportDownload(desiredSheets);
              } finally {
                setIsExporting(false);
              }
            }}
            loading={isExporting}
            radius={"xs"}
            size="xs"
            fullWidth
          >
            Download
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
